import React from 'react'
import * as RadixDropdown from '@radix-ui/react-dropdown-menu'

import { dropdownContent, dropdownContentItem } from './DropdownMenu.css'
import clsx from 'clsx'

export const DropdownMenu = ({
  children,
  ...rest
}: React.ComponentProps<typeof RadixDropdown.Root>) => {
  return <RadixDropdown.Root {...rest}>{children}</RadixDropdown.Root>
}

const DropdownMenuTrigger = ({ children, asChild = true }) => {
  return (
    <RadixDropdown.Trigger asChild={asChild}>{children}</RadixDropdown.Trigger>
  )
}

const DropdownMenuContent = ({
  children,
  className = '',
  sideOffset = 5,
  ...rest
}: RadixDropdown.DropdownMenuContentProps) => {
  return (
    <RadixDropdown.Portal>
      <RadixDropdown.Content
        avoidCollisions={false}
        className={clsx([dropdownContent, className])}
        sideOffset={sideOffset}
        {...rest}
      >
        {children}
      </RadixDropdown.Content>
    </RadixDropdown.Portal>
  )
}

const DropdownMenuItem = React.forwardRef<
  HTMLDivElement,
  RadixDropdown.DropdownMenuItemProps
>(({ children, className = '', ...rest }, ref) => {
  return (
    <RadixDropdown.Item
      className={clsx([dropdownContentItem, className])}
      ref={ref}
      {...rest}
    >
      {children}
    </RadixDropdown.Item>
  )
})

DropdownMenuItem.displayName = 'DropdownMenuItem'
DropdownMenu.Trigger = DropdownMenuTrigger
DropdownMenu.Content = DropdownMenuContent
DropdownMenu.Item = DropdownMenuItem
